import Vue from 'vue';
import App from './App';
import router from './router';
import rem from './libs/rem.js';
import bus from './libs/bus.js';
import utils from './libs/utils.js';
import echart from 'echarts'
import day from "dayjs";
import store from './store';

import ElementUI from 'element-ui';
import Plugin from 'v-fit-columns';
import {
  Message,
  Alert
} from 'element-ui'
import dataV from '@jiaminghi/data-view'
import 'element-ui/lib/theme-chalk/index.css';
import i18n from './locales/index'
Vue.prototype.dayjs = day;
Vue.prototype.$utils = utils
require('script-loader!file-saver'); //保存文件用

require('script-loader!vendor/Blob'); //转二进制用

import 'babel-polyfill';

require('script-loader!xlsx/dist/xlsx.core.min'); //xlsx核心

Vue.$message = Vue.$message ? Vue.$message : Message
Vue.$alert = Vue.$alert ? Vue.$alert : Alert;
Vue.$echarts = Vue.$echarts ? Vue.$echarts : echart;
Vue.use(dataV)
Vue.use(Plugin);

// Vue.config.devtools = true;

// let token = localStorage.getItem('adminToken')

axios.create({
  headers: "token"
});

/*function getCookie(name) {
  console.log(document.cookie)
  return 'f15sd1f5s'
}*/

Vue.prototype.$echarts = echart;

// Vue.use(ElementUI);
// Vue.use(ElementUI);
Vue.use(ElementUI,
  {
    i18n: (key, value) => i18n.t(key, value) // 在注册Element时设置i18n的处理方法,可以实现当点击切换按钮后，elementUI可以自动调用.js语言文件实现多语言切换
  }
)

router.beforeEach((to, from, next) => {

  let token = localStorage.getItem('adminToken');
  if (to.path == '/login') {
    next();
  } else if (token) {
    next();
  } else {
    next({
      path: "/login"
    });
  }

  // if (token) {
  //   //如果有就直接通过
  //   next();
  // } else {
  //   if (to.path == '/login') {
  //     //如果是登录页面路径，就直接next()
  //     next();
  //   } else {
  //     //不然就跳转到登录
  //     next({
  //       path: "/login"
  //     });
  //   }
  // }

  setTimeout(function () {
    //派发路由变化事件 用于pageTab.vue
    bus.$emit('routerChange', to, from)
    //派发 leftActive事件 用于left.vue
    bus.$emit('leftActive', to, from)
    //派发 用于layout.Vue
    bus.$emit('layout_Tab', to)
  }, 20)
  next()
})


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: {
    App
  },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js